import InvestEditRatioForm from './InvestEditRatioForm';

export default InvestEditRatioForm;
